<template>
  <div
    class="loading-spinner"
    :style="`--size: ${size}px;`"
  ></div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: Number,
      default: 48
    }
  }
};
</script>

<style lang="scss" scoped>
  .loading-spinner {
    width: var(--size);
    height: var(--size);
    margin: 0 auto;
    border-width: calc(var(--size) / 8);
    border-style: solid;
    border-color: $ink-lighter $ink-lighter $ink-lighter transparent;
    border-radius: 50%;
    transform: rotate(0deg);
    animation: linear 1s infinite circle-spin-1-animation;
  }

  @keyframes circle-spin-1-animation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>
